<template>
  <div class="manualRecord">
    <b-container class="bv-example-row px-0">
      <b-row class="mx-0">
        <div class="col-12 px-0">
          <b-row class="mx-0 mb-3">
            <b-col cols="1"> </b-col>

            <b-col cols="10">
              <b-col
                cols="12"
                class="p-0 m-0 mt-4"
                style="font-size: 1.75rem; color: #000000"
              >
                <span class="m-auto">人工處理紀錄</span>
              </b-col>

              <div class="container" style="margin-top: 2rem">
                <div class="col-12 row text-left mb-2">
                  <div class="mr-2" style="width: 9rem">
                    <p class style="margin-bottom: 0.625rem">
                      派工單號
                    </p>
                    <b-form-input
                      style="
                              max-width: 9rem;
                              height: 2.375rem;
                              line-height: 1.375rem;
                              font-size: 0.875rem;
                              border: 2px solid rgb(255, 255, 255);
                              box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 3px 0px;
                              color: rgb(95, 95, 95);
                            "
                      v-model="workID"
                    ></b-form-input>
                  </div>
                  <div class="mr-2" style="width: 9rem">
                    <p class style="margin-bottom: 0.625rem">製程</p>
                    <b-form-select
                      v-model="processSelected"
                      :options="orgProcessOption"
                      class=""
                      style="
                        max-width: 9rem;
                        height: 2.375rem;
                        line-height: 1.375rem;
                        font-size: 0.875rem;
                        border: 2px solid rgb(255, 255, 255);
                        box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 3px 0px;
                        color: rgb(95, 95, 95);
                      "
                    >
                      <template #first>
                        <b-form-select-option :value="null" disabled
                          >-- 選擇製程 --</b-form-select-option
                        >
                      </template>
                    </b-form-select>
                  </div>
                  <div class="mr-2" style="width: 4.25rem">
                    <b-button
                      class="p-0"
                      @click="queryFoolproof"
                      style="
                        margin-top: 38px;
                        background-color: #4b8c80;
                        width: 4.25rem;
                        height: 2rem;
                        font-size: 1.125rem;
                      "
                      >查詢</b-button
                    >
                  </div>
                </div>
                <b-row>
                  <commonQueryIoT />
                </b-row>
              </div>

              <b-col cols="12" class="text-left mx-0" style="margin-top: 2rem;">
                <template v-if="functionName == 'manualRecordOrder'">
                  <div class="mb-3">
                    <b-button
                      v-for="n in manualRecordDataItem.length"
                      :key="n"
                      class="mr-2 mb-1 records-button"
                      :class="{ active: userSelectCode == n }"
                      @click="userSelectCode = n"
                    >
                      {{ n }}
                    </b-button>
                  </div>
                </template>
                <template
                  v-else-if="functionName == 'manualRecordUser'"
                ></template>
                <manualRecordData class="text-left" />
              </b-col>
            </b-col>

            <b-col cols="1"> </b-col>
          </b-row>
        </div>
      </b-row>
    </b-container>
  </div>
</template>

<script>
// import $ from "jquery";
import manualRecordData from "@/components/manualRecordData.vue";
import commonQueryIoT from "@/components/commonQueryIoT.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "manualRecord",
  data() {
    return {
      workID: null,
      processSelected: null,
      functionName: "",
      manualRecordDataItem: [],
      userSelectCode: 1
    };
  },
  created: function() {
    this.setCommonQueryData();
    this.setQueryInput();
  },
  mounted: function() {
    let vm = this;
  },
  components: {
    manualRecordData,
    commonQueryIoT
  },
  watch: {
    mainQueryResponse: {
      handler() {
        let vm = this;
        vm.functionName = "manualRecordUser";
        let manualRecordData = vm.mainQueryResponse[0]["manualRecordData"];
        if (manualRecordData.length == 0) {
          vm.set_alertMsg("查無資料");
          vm.settimeout_alertModal();
        }
        vm.set_manualRecordDataItem(manualRecordData);
      }
    },
    userSelectCode: {
      handler() {
        let vm = this;
        if (vm.functionName == "manualRecordOrder") {
          vm.set_manualRecordDataItem(
            vm.manualRecordDataItem[vm.userSelectCode - 1]
          );
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      axiosResult: "commonaxios/get_axiosResult",
      mainQueryResponse: "commonqueryiot/get_queryResponse",
      orgProcessOption: "commonqueryiot/get_orgProcessOption",
      selectPage: "getlogin/get_selectPage"
    })
  },
  methods: {
    ...mapActions({
      axiosAction: "commonaxios/axiosAction",
      set_alertMsg: "alertmodal/set_alertMsg",
      settimeout_alertModal: "alertmodal/settimeout_alertModal",
      set_phpfunction: "commonqueryiot/set_phpfunction",
      set_selectTag: "commonqueryiot/set_selectTag",
      set_selectTagCheck: "commonqueryiot/set_selectTagCheck",
      trigger_loadScreenModal: "loadscreenmodal/trigger_loadScreenModal",
      set_manualRecordDataItem: "manualRecordData/set_manualRecordDataItem",
      clear_manualRecordDataItem: "manualRecordData/clear_manualRecordDataItem"
    }),
    setCommonQueryData() {
      let vm = this;
      vm.set_phpfunction("queryManualRecordUserData");
    },
    setQueryInput() {
      let vm = this;
      vm.set_selectTag({
        process: false,
        deviceCode: false,
        productCode: false,
        SourceNo: false,
        userCode: false,
        changeUserCode: true
      });
      vm.set_selectTagCheck({
        startTime: true,
        endTime: true,
        process: false,
        deviceCode: false,
        productCode: false,
        SourceNo: false,
        userCode: false,
        changeUserCode: false
      });
    },
    queryFoolproof() {
      let vm = this;
      let workID = vm.workID;
      let processSelected = vm.processSelected;
      if (workID == "" || workID == null) {
        vm.set_alertMsg("請輸入派工單號");
        vm.settimeout_alertModal();
        return;
      }
      if (processSelected == "" || processSelected == null) {
        vm.set_alertMsg("請選擇製程");
        vm.settimeout_alertModal();
        return;
      }
      vm.reset(["workID", "processSelected"]);
      vm.functionName = "manualRecordOrder";
      vm.queryManualRecord(workID, processSelected);
    },
    queryManualRecord(workID, processSelected) {
      let vm = this;
      vm.trigger_loadScreenModal();
      var params = {};
      params["vuePage"] = vm.selectPage;
      params["methods"] = "POST";
      params["workID"] = workID;
      params["processSelected"] = processSelected;
      params["whichFunction"] = "queryManualRecordData";
      vm.axiosAction(params).then(() => {
        vm.trigger_loadScreenModal();
        var result = vm.axiosResult;
        console.log(result.QueryTableData);
        if (result["Response"] == "ok") {
          result.QueryTableData;
          let manualRecordData = result.QueryTableData;
          vm.manualRecordDataItem = manualRecordData;
          vm.set_manualRecordDataItem(vm.manualRecordDataItem[0]);
          if (manualRecordData.length == 0) {
            vm.set_alertMsg(`查無資料`);
            vm.settimeout_alertModal();
          }
        } else {
          vm.set_alertMsg(result.Response);
          vm.settimeout_alertModal();
        }
      });
    },
    //資料reset
    reset(keep) {
      var def = this.$options.data();
      for (var i = 0; i < keep.length; i++) {
        def[keep[i]] = this[keep[i]];
      }
      Object.assign(this.$data, def);
      //https://codepen.io/karimcossutti/pen/ObXyKq
    }
  },
  destroyed() {
    this.clear_manualRecordDataItem();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
<style lang="scss">
.records-button {
  height: 2rem;
  line-height: 2rem;
  padding: 0px;
  width: 4.25rem;
}
.records-button.active {
  background-color: #4b8c80 !important;
  border-color: #4b8c80 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/manualRecord.vue